/**
 * Sunday Clovr redesign — small runtime helpers.
 *
 * 1. Loading intro (prototype app.js): the brown .page-loader sheet is
 *    shown by an inline script in layout/theme.liquid with a 6 s fail-open
 *    timer. It finishes here when the first hero image and the fonts are
 *    ready, when "Enter website" is pressed, or when the welcome poster is
 *    closed (welcome-poster.js). Under reduced motion the sheet simply
 *    disappears (no fade).
 *
 * 2. Menu overlay position: the base theme's full-screen menu overlay is
 *    restyled as the prototype's nav panel that hangs under the header.
 *    The header's bottom edge moves (announcement bar at the top of the
 *    page, sticky header once scrolled), so it is measured when the
 *    overlay opens and handed to CSS as --scr-menu-top.
 */

/* --- 1. Loading intro -------------------------------------------------- */
(() => {
  const loader = document.querySelector('[data-scr-loader]');
  if (!loader) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    clearTimeout(window.scrLoaderTimeout);
    loader.classList.add('is-done');
    document.documentElement.classList.remove('scr-loading');
    const hide = () => { loader.hidden = true; };
    if (reduced) hide(); else setTimeout(hide, 500);
  };
  loader.querySelector('[data-scr-loader-skip]')?.addEventListener('click', finish);
  document.addEventListener('scr:loader:finish', finish);
  addEventListener('pageshow', (e) => { if (e.persisted) finish(); });

  const heroImage = document.querySelector('.scr-hero__img--1, .scr-hero__img');
  const heroReady = !heroImage || heroImage.complete
    ? Promise.resolve()
    : new Promise((resolve) => {
        heroImage.addEventListener('load', resolve, { once: true });
        heroImage.addEventListener('error', resolve, { once: true });
      });
  const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
  Promise.all([heroReady, fontsReady]).then(finish, finish);
})();

/* --- 2. Menu overlay position ----------------------------------------- */
const setMenuTop = () => {
  const header = document.querySelector('header.shopify-section-group-header-group')
    || document.querySelector('#header-component');
  if (!header) return;
  const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  document.documentElement.style.setProperty('--scr-menu-top', `${bottom}px`);
};

document.addEventListener('sc:overlay', (e) => {
  if (e.detail?.open && e.detail?.name === 'menu') setMenuTop();
});
document.addEventListener('click', (e) => {
  if (e.target.closest?.('[data-sc-open="menu"]')) setMenuTop();
}, true);
addEventListener('resize', () => {
  if (document.querySelector('[data-sc-overlay="menu"].is-open')) setMenuTop();
}, { passive: true });
